import React from 'react'
import { BreadcrumbLink } from '../../Shared/BreadCrumb/BreadCrumb'
import SubnavBar from '../../Shared/SubnavBar'

type Props = {
  title?: string
  name?: string
  onBack ?: () => void
}

const Breadcrumbs: React.ComponentType<Props> = props => {
  const { name, title = 'รายการแก้ไข', onBack } = props

  const breadcrumbs: BreadcrumbLink[] = [
    {
      url: '/qcdashboard',
      title: 'Home',
      icon: '/home.png',
      active: true,
      showTitle: false,
    },
    {
      url: '/qcdashboard',
      title: 'งานทั้งหมด',
      active: true,
      showTitle: true,
    },
    {
      url: '/qcdashboard',
      title: 'CM กำลังตรวจสอบ',
      active: true,
      showTitle: true,
    },
  ]

  if (name) {
    breadcrumbs.push({
      url: '',
      title: title,
      active: true,
      showTitle: true,
      onClick : onBack
    })

    breadcrumbs.push({
      url: '',
      title: name,
      active: false,
      showTitle: false,
    })
  }else{
    breadcrumbs.push({
      url: '/',
      title: title,
      active: false,
      showTitle: false,
    })
  }

  return <SubnavBar breadcrumbs={breadcrumbs} hideSearch={true} />
}

export default Breadcrumbs
